export default __webpack_public_path__ + "static/media/vib_3.4b0b3c31.png";